module.exports = __webpack_public_path__ + "21a21fde961f262192a7ca0d7463b094.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/misc/message-16-help.png
// module id = 222
// module chunks = 0